import { render, staticRenderFns } from "./tablePanel.vue?vue&type=template&id=20da4eec&scoped=true&"
import script from "./tablePanel.vue?vue&type=script&lang=js&"
export * from "./tablePanel.vue?vue&type=script&lang=js&"
import style0 from "./tablePanel.vue?vue&type=style&index=0&id=20da4eec&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20da4eec",
  null
  
)

export default component.exports